import Model from '@/models/Model.js';

export default class Dashboard extends Model {
    static entity = 'dashboard';

    static modelName = 'Dashboard';

    static state() {
        return {
            activePageFolder: null,
            breadcrumb: [],
        };
    }
}
